import { object } from 'prop-types';
import React, { useCallback } from 'react';
import Select from 'react-select';
import { getSelectStyles } from '../../utils/react-select-style';
import CustomMultiSelect from './custom-multiselect';
import InfoOverlay from '../info-overlay/info-overlay';

const CustomSelect = ( props ) => {

    const { attributes } = props;
    const { label, width, height, data, variable, onSelectChange, isSearchable, defaultValue, isMultiSelect, infoOverlayData } = attributes;

    const onValueChange = useCallback( e => onSelectChange( variable, e.value, e.label ) );

    return (
        <>
            <p className="filter-label">
                { label }
                { infoOverlayData && infoOverlayData.showInfoButtonOnly && <InfoOverlay data={ infoOverlayData } /> }
            </p>

            {
                isMultiSelect

                    ? <CustomMultiSelect { ...props } />

                    : (
                        <Select
                            className="chart-selection"
                            name="chart-selection"
                            defaultValue={ defaultValue }
                            options={ data }
                            menuPortalTarget={ document.body }
                            styles={ getSelectStyles( width, height, false, false, false, true ) }
                            onChange={ onValueChange }
                            isSearchable={ isSearchable }
                        />
                    )
            }
        </>

    );

};

CustomSelect.propTypes = {
    attributes: object,
};

export default CustomSelect;
